import I7Detail from './I7Detail';

export default I7Detail;
